module.exports = __webpack_public_path__ + "static/media/SomeoneElseImage.d4c9849a.svg";